import { createSlice } from '@reduxjs/toolkit';
import { LISTING_INITIAL_STATE } from 'src/components/VendorPortal/ListingLayout/shared/constants';
import { REQUEST_SORT_KEYS } from 'src/views/VendorPortal/Request/constants';
import { CLAIM_REQUEST_SCREEN_KEYS } from 'src/views/VendorPortal/Request/SidePanel/ClaimPanel/constants';
import { PASS_REQUEST_SCREEN_KEYS } from 'src/views/VendorPortal/Request/SidePanel/PassPanel/constants';
import extraReducers from './extra-reducers';
import reducers from './reducers';
import type { RequestDataType, RequestStateType } from './types';

const requestInitialState: RequestStateType = {
  ...LISTING_INITIAL_STATE,
  categoryOptions: [],
  data: [],
  source: {} as RequestDataType,
  filters: {
    category: [''],
    status: ['claim_pending'],
  },
  sortBy: `-${REQUEST_SORT_KEYS.RECEIVED}`,
  sidePanels: {
    requestDetails: {
      isLoading: false,
      isOpen: false,
      needToRefetch: false,
      showIssuesWarning: false,
      hasDetailsError: false,
    },
    issueDetails: {
      isLoading: false,
      isOpen: false,
    },
    passRequest: {
      currentScreen: PASS_REQUEST_SCREEN_KEYS.SELECT_REASON,
      isLoading: false,
      isOpen: false,
    },
    requestAvailability: {
      data: undefined,
      isOpen: false,
      isPending: false,
    },
    claimRequest: {
      currentScreen: CLAIM_REQUEST_SCREEN_KEYS.REVIEW_AND_CONFIRM,
      isLoading: false,
      isOpen: false,
    },
  },
};

const requestSlice = createSlice({
  name: 'request',
  initialState: requestInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  clearRequestListFilters,
  filterRequestList,
  searchRequestList,
  setRequestFilterMapping,
  sortRequestList,
  removeItemFromRequestList,
  openRequestDetailsSidePanel,
  closeRequestDetailsSidePanel,
  retryRequestDetails,
  openClaimRequestSidePanel,
  closeClaimRequestSidePanel,
  updateClaimRequestTabSidePanel,
  openRequestIssueDetailsSidePanel,
  closeRequestIssueDetailsSidePanel,
  openPassRequestSidePanel,
  closePassRequestSidePanel,
  updatePassRequestTabSidePanel,
  openRequestAvailabilitySidePanel,
  closeRequestAvailabilitySidePanel,
  updateRequestViewedInList,
  resetRequestListState,
} = requestSlice.actions;

export default requestSlice.reducer;
